import React from "react";
import { motion } from "framer-motion";
import { useT } from "../i18n";

export default function LegalPage({ tKey, testid }) {
  const { t } = useT();
  const sections = t(`${tKey}.sections`) || [];
  return (
    <article className="bg-[#f6f4ee] py-24 md:py-36" data-testid={testid}>
      <div className="max-w-[900px] mx-auto px-5 sm:px-8 lg:px-14">
        <motion.header
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <div className="eyebrow mb-6">Legal · 2026</div>
          <h1 className="font-serif tracking-tight leading-[1.05] text-[clamp(2rem,5vw,4rem)] text-[#1a211c]">
            {t(`${tKey}.title`)}
          </h1>
          <div className="mt-4 text-[0.85rem] font-mono tracking-widest uppercase text-[#3d4f42]">
            {t(`${tKey}.updated`)}
          </div>
        </motion.header>

        <p className="mt-10 text-[1.05rem] leading-relaxed text-[#1a211c]/80">
          {t(`${tKey}.intro`)}
        </p>

        <div className="mt-14 space-y-10">
          {sections.map((s, i) => (
            <motion.section
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.04 }}
              className="border-t border-[#1a211c]/12 pt-8"
            >
              <h2 className="font-serif text-[#1a211c] leading-tight text-2xl md:text-3xl mb-4">
                {s.h}
              </h2>
              <p className="text-[1rem] leading-relaxed text-[#1a211c]/80">{s.b}</p>
            </motion.section>
          ))}
        </div>
      </div>
    </article>
  );
}
